// eslint-disable-next-line
import { h, Component } from 'preact';
import classNames from 'classnames';

import styles from './index.scss';

const HorizontalLine = props => {
    const { extraClass = '' } = props;

    const btnClasses = classNames({
        [styles.horizontalLine]: true,
        [extraClass]: true,
    });

    return <div className={btnClasses} />;
};

export default HorizontalLine;
